<!-- ========== Left Sidebar Start ========== -->
<div class="left-side-menu" (clickOutside)="hideMenu()" [exclude]="'.open-left'" [excludeBeforeClick]="true">
    <ngx-simplebar class="rv2023">
        <!-- User box -->
        <!-- <div class="user-box text-center">
            <img [src]="loggedInUser.avatar" alt="user-img" title="Mat Helme" class="rounded-circle avatar-md">
            <div ngbDropdown>
                <a href="javascript: void(0);" class="text-dark h5 mt-2 mb-1 d-block" id="profileMenu"
                    ngbDropdownToggle>{{loggedInUser.name}}</a>
                <div class="user-pro-dropdown" ngbDropdownMenu aria-labelledby="profileMenu">

                 
                    <a href="javascript:void(0);" class="notify-item" ngbDropdownItem>
                        <i class="fe-user me-1"></i>
                        <span>My Account</span>
                    </a>

                   
                    <a href="javascript:void(0);" class="notify-item" ngbDropdownItem>
                        <i class="fe-settings me-1"></i>
                        <span>Settings</span>
                    </a>

                  
                    <a href="javascript:void(0);" class="notify-item" ngbDropdownItem>
                        <i class="fe-lock me-1"></i>
                        <span>Lock Screen</span>
                    </a>

                    
                    <a href="javascript:void(0);" class="notify-item" ngbDropdownItem>
                        <i class="fe-log-out me-1"></i>
                        <span>Logout</span>
                    </a>

                </div>
            </div>
            <p class="text-muted">Admin Head</p>
        </div> -->

        <div class="logo-box">
            <a [routerLink]="'../home'" class="logo logo-dark text-center">
                <span [ngClass]="{'box-small':isEnable()==true}" class="logo-sm">
                    <img src="../assets/images/logoexpandbsscomp.svg" alt="" style="height: 30px !important;">
                    <i *ngIf="isSmallScreen()" (click)="hideMenu()" class="mdi mdi-arrow-left arrowLeft">

                    </i>
                </span>
                <span class="logo-lg box-small">
                    <img src="../assets/images/logoexpandbssWhite.svg" alt="">
                </span>
            </a>

            <a [routerLink]="'../home'" class="logo logo-light text-center">
                <span [ngClass]="{'box-small':isEnable()==true}" class="logo-sm ">
                    <img src="../assets/images/logoexpandbsscomp.svg" alt="" style="height: 30px !important;">
                    <i *ngIf="isSmallScreen()" (click)="hideMenu()" class="mdi mdi-arrow-left arrowLeft">

                    </i>
                </span>
                <span class="logo-lg ">
                    <img src="../assets/images/logoexpandbssWhite.svg" alt="">
                </span>
            </a>
        </div>

        <!--- Sidemenu -->
        <div id="sidebar-menu" class="sideBar">
            <ul id="side-menu" >
                <li class="nav-user" id="profileMenuDropdown" href="javascript:void(0)" aria-expanded="false" style="display: flex;
                    flex-direction: column; margin-bottom: 20px; padding: 0 8px !important;">
                    <span (click)="profileIcon()" class="account-user-avatar"
                        *ngIf="accountPhoto !== 'null' && accountPhoto!== null && accountPhoto!== undefined">
                        <img [src]="accountPhoto" alt="user-image" class="rounded-circle avatarHeader">
                    </span>
                    <span class="bottomMenu" style="font-size: 12px;color: white;">
                        {{loggedInUser?.firstName}}
                    </span>

                </li>
                <ng-container *ngFor="let menu of menuItems;let i = index">
                    <li *ngIf="menu.isTitle" class="menu-title" [class.mt-2]="i!==0" [class.disabled]="menu.disabled">
                        {{menu.label}}
                    </li>
                    <ng-container *ngIf="!menu.isTitle">

                        <ng-container *ngIf="!hasSubmenu(menu)">
                            <ng-container
                                *ngTemplateOutlet="MenuItem;context:{menu: menu, linkClassName: 'side-nav-link-ref'}">
                            </ng-container>
                        </ng-container>


                        <ng-container *ngIf="hasSubmenu(menu)">
                            <ng-container
                                *ngTemplateOutlet="MenuItemWithChildren;context:{menu: menu, linkClassName: 'side-nav-link-ref', subMenuClassNames: 'nav-second-level'}">
                            </ng-container>
                        </ng-container>
                    </ng-container>

                </ng-container>
                <div class="whiteLine">
                </div>
                <li class="pointer" style="font-size: 22px;" (click)="logout()">
                    <a>
                        <i class="mdi mdi-logout "></i>
                        <span class="bottomMenu" style="font-size: 12px;">
                            {{'MISC.LOGOUT' | translate}}
                        </span>                        
                    </a>
                </li>
                <li class="pointer" style="font-size: 22px;" (click)="changeSidebarWidth()">
                    <a>
                        <i class="fe-menu white" style="color: white;"></i>
                    </a>
                </li>
            </ul>

        </div>
        <!-- End Sidebar -->
        <!-- <div>
            <ul class="menuitem-active" style="padding: 0;
            text-align: center;">
                <a class="pointer" style="text-align: center;font-size: 22px;" (click)="changeSidebarWidth()">
                    <i class="fe-menu white" style="color: white;"></i>

                </a>
            </ul>
        </div> -->

        <!-- <li>
            <button class="button-menu-mobile waves-effect waves-light d-none d-lg-block"
                (click)="changeSidebarWidth()" *ngIf="layoutType!=='horizontal'">
                <i class="fe-a black"></i>
            </button>
        </li>   -->

    </ngx-simplebar>

</div>
<!-- Left Sidebar End -->

<!-- Reusable Templates -->
<ng-template #MenuItemWithChildren let-menu="menu" let-linkClassName="linkClassName"
    let-subMenuClassNames="subMenuClassNames">
    <li [ngClass]="{'menuitem-active': activeMenuItems.includes(menu.key)}">
        <a href="javascript: void(0)" [class]="linkClassName" (click)="toggleMenuItem(menu,collapse)"
            [attr.aria-expanded]="!menu.collapsed" [attr.data-menu-key]="menu.key">
            <i class="{{menu.icon}}" *ngIf="menu.icon"></i>
            <span class="badge bg-{{menu.badge.variant}} rounded-pill float-end"
                *ngIf="menu.badge">{{menu.badge.text}}</span>
            <span>{{ menu.label | translate }}</span>
            <span class="menu-arrow" *ngIf="!menu.badge"></span>
        </a>
        <a ngbDropdownToggle class="nav-link nav-user  me-0 waves-effect waves-light" id="profileMenuDropdown"
            href="javascript:void(0)" aria-expanded="false">
            <span (click)="profileIcon()" class="account-user-avatar"
                *ngIf="accountPhoto !== 'null' && accountPhoto!== null && accountPhoto!== undefined">
                <img [src]="accountPhoto" alt="user-image" class="rounded-circle avatarHeader">
            </span>
            <span class="pro-user-name ms-1 black textFormat">
                {{loggedInUser?.firstName}} <i class="mdi mdi-chevron-down black"></i>
            </span>

        </a>
        <div #collapse="ngbCollapse" [(ngbCollapse)]="menu.collapsed">
            <ul [class]="subMenuClassNames">
                <ng-container *ngFor="let child of menu.children">
                    <ng-container *ngIf="hasSubmenu(child)">
                        <ng-container
                            *ngTemplateOutlet="MenuItemWithChildren;context:{menu: child, linkClassName: 'side-nav-link-ref', subMenuClassNames: 'nav-second-level'}">
                        </ng-container>
                    </ng-container>

                    <ng-container *ngIf="!hasSubmenu(child)">
                        <ng-container
                            *ngTemplateOutlet="MenuItem;context:{menu: child, linkClassName: 'side-nav-link-ref'}">
                        </ng-container>
                    </ng-container>
                </ng-container>
            </ul>
        </div>
    </li>
</ng-template>

<ng-template #MenuItem let-menu="menu" let-linkClassName="linkClassName">
    <li [ngClass]="{'menuitem-active': activeMenuItems.includes(menu.key)}" [class.disabled]="menu.disabled">
        <ng-container *ngTemplateOutlet="MenuItemLink;context:{menu: menu, className: linkClassName}">
        </ng-container>
    </li>
</ng-template>

<ng-template #MenuItemLink let-menu="menu" let-className="className">
    <a [routerLink]="menu.link" [class]="className" [ngClass]="{'active': activeMenuItems.includes(menu.key)}"
        [attr.data-menu-key]="menu.key">
        <div class="display: inline-flex">
            <i class="{{menu.icon}}" *ngIf="menu.icon"></i>
            <span class="badge bg-{{menu.badge.variant}}  float-end" *ngIf="menu.badge">{{menu.badge.text}}</span>
            <span>{{ menu.label | translate }}</span>
        </div>
    </a>
</ng-template>